<template>
  <div class="attention_content">
      <div class="attention_entity">
          <div class="attention_content_title">{{defaultGroupItem.name}}</div>
          <!-- <div class="attention_content_nav">
            <Menu mode="horizontal" theme="light" :active-name="select" @on-select="haddleSelect">
                <MenuItem name="comp">公司</MenuItem>
                <MenuItem name="org">机构</MenuItem>
            </Menu>
          </div> -->
          <div class="entity_checked" v-if="select == 'comp'">
              <div class="checked1" v-if="default_comp.length > 0 || default_org.length > 0">
                  已关注
              </div>
              <div class="checked2">
                  <ul class="checked_ul clear" v-if="default_comp.length > 0 || default_org.length > 0">
                      <li v-for="(item,index) in default_comp">
                          <div class="logo_img" @click="goEntityDetail(item.uid, 'comp')">
                              <img :src="item.logo_path | logo_show" />
                          </div>
                          <div class="entity_info">
                              <p class="p1 clear"><span class="span_name" @click="goEntityDetail(item.uid)">{{item.short_name}}</span><span class="span_tag" v-if="item.round_id">{{item.round_id | deal('round')}}</span></p>
                              <p class="p2" v-if="item.description">{{item.description}}</p>
                              <p class="p2" v-else>暂无描述</p>
                          </div>
                          <div class="entity_chk">
                              <i class="iconfont">&#xe64b;</i>
                          </div>
                      </li>
                      <li v-for="(item,index) in default_org">
                          <div class="logo_img" @click="goEntityDetail(item.uid, 'org')">
                              <img :src="item.logo_path | logo_show" />
                          </div>
                          <div class="entity_info">
                              <p class="p1 clear"><span class="span_name" @click="goEntityDetail(item.uid)">{{item.short_name}}</span><span class="span_tag" v-if="item.round_id">{{item.round_id | deal('round')}}</span></p>
                              <p class="p2" v-if="item.description">{{item.description}}</p>
                              <p class="p2" v-else>暂无描述</p>
                          </div>
                          <div class="entity_chk">
                              <i class="iconfont">&#xe64b;</i>
                          </div>
                      </li>
                  </ul>
                  <Nothing v-else><p>该组暂无关注机构</p></Nothing>
              </div>
              <Spin fix class="a-fix" v-if="dataLoading1 && dataLoading2">
                  <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
                  <div>Loading</div>
              </Spin>
          </div>

      </div>
  </div>
</template>

<script>
import { attention_mixins } from 'js/attention_mixins'
import { findEntity } from '../../../service'
import Nothing from '@/components/Nothing.vue'

export default {
  name: 'AttentionCompany',
  props: ['defaultGroupItem'],
  components: {
    Nothing
  },
  data() {
    return {
      dataLoading1: true,
      dataLoading2: true,
      show_entity_comp: true,
      select: 'comp',
      default_comp: [],
      default_org: []
    }
  },
  methods: {
    goEntityDetail(uid, type) {
      if(type == 'comp'){
        this.$router.push({name: 'CompanyDetail', params: {uid: uid}})
      }else{
        this.$router.push({name: 'OrgDetail', params: {uid: uid}})
      }
    },
    haddleSelect(val) {
      this.select = val
    },
    async findEntity() {
      let comp = this.defaultGroupItem.entitys.filter(item => item.type == '0').map(item => item.id)
      let org = this.defaultGroupItem.entitys.filter(item => item.type == '1').map(item => item.id)
      if(comp.length > 0){
        let res = await findEntity({type: 0, ids: comp, keyword: ""}, (error) => {
          this.$Message.error('请求错误！')
        })
        if(res.status == 'success') {
          this.$set(this.$data, 'default_comp', res.res)
          this.dataLoading1 = false
        } else {
          console.log(res)
        }
      }
      if(org.length > 0){
        let res1 = await findEntity({type: 1, ids: org, keyword: ""}, (error) => {
          this.$Message.error('请求错误！')
        })
        if(res1.status == 'success') {
          this.$set(this.$data, 'default_org', res1.res)
          this.dataLoading2 = false
        } else {
          console.log(res1)
        }
      }
    }
  },
  created() {
    this.findEntity()
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/attention.stylus'
.attention_entity
  .entity_checked
    display: block
    border-bottom: 0
    padding: 30px
    .checked1
      flex: none
      font-size: 14px
      commonColor(rgba(255,255,255,.9), #333333)
    .checked2
      flex: none
      margin-top: 10px
      .checked_ul
        >li
          width: 298px
          .entity_chk
            text-align: right
            i.iconfont
              font-size: 17px
              // color: #797B83
              commonColor(#797B83, #D5D5D5)
.nothing
  padding: 70px 0
</style>
